import { Page } from 'Common/Page/Page'
import { Box, Paper, Tab, Tabs } from '@mui/material'
import { PageHeader, TabPanel, Button } from 'Common/Supplyvue-ui'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { useParams } from 'react-router-dom'
import {
  useTemplateOutputs,
  useFetchTemplateRunRateOutputs,
  useFetchTemplateSummaryOutputs,
  useTemplateComparison,
} from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.data'
import { PreferredMethod } from 'Features/Projects/Scenarios/Templates/PlanTemplateSummary.types'
import { Loader } from 'Common/Loader/Loader'
import { useState } from 'react'
import { DetailsView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Details/Details.view'
import { ResultsView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Results/Results.view'
import { RunRateView } from 'Features/Projects/Scenarios/Templates/TemplateResults/RunRate/Results.RunRate.view'
import { ErrorDisplay } from 'Common/Error/Error'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { ComparisonView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Comparison/Comparison.view'

export const TemplateResultsView = () => {
  const { view_width, view_height } = useWindowSize()
  const { projectId, scenarioId, workcentreId, preferredTemplate } = useParams<{
    projectId: string
    scenarioId: string
    workcentreId: string
    preferredTemplate: PreferredMethod
  }>() as {
    projectId: string
    scenarioId: string
    workcentreId: string
    preferredTemplate: PreferredMethod
  }

  const {
    data: templateOutputsData,
    isLoading: isTemplateOutputsLoading,
    isError: isTemplateOutputsError,
  } = useTemplateOutputs({
    projectId,
    scenarioId,
    workcentreId,
    preferredMethod: preferredTemplate,
  })

  const {
    data: templateComparison,
    isLoading: isTemplateComparisonLoading,
    isError: isTemplateComparisonError,
  } = useTemplateComparison({
    projectId,
    scenarioId,
    workcentreId,
    preferredMethod: preferredTemplate,
  })

  const {
    data: runRateData,
    isLoading: isrunRateLoading,
    isError: isrunRateError,
  } = useFetchTemplateRunRateOutputs({
    projectId,
    scenarioId,
    workcentreId,
    preferredMethod: preferredTemplate,
  })

  const {
    data: templateSummaryData,
    isLoading: isTemplateSummaryLoading,
    isError: isTemplateSummaryError,
  } = useFetchTemplateSummaryOutputs({
    projectId,
    scenarioId,
    workcentreId,
    preferredMethod: preferredTemplate,
  })
  // Maybe change this to have individual loaders for each tab
  const isLoading =
    isTemplateOutputsLoading || isTemplateSummaryLoading || isrunRateLoading

  const isError =
    isTemplateOutputsError || isTemplateSummaryError || isrunRateError

  const TABS = {
    RESULTS_TAB: 'tab-0',
    DETAILS_TAB: 'tab-1',
    RUNTIME_TAB: 'tab-2',
    COMPARISON_TAB: 'tab-3',
  }
  const [selectedTab, setSelectedTab] = useState(TABS.RESULTS_TAB)
  const width = view_width
  const height = view_height

  const Return = () => {
    return (
      <Box display="flex">
        <Button
          variant="text"
          sx={{ fontWeight: 600 }}
          startIcon={<ArrowBackIcon />}
          onClick={() => window.history.back()}
        >
          Back
        </Button>
      </Box>
    )
  }

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        width="100%"
        maxHeight={height}
      >
        <PageHeader title="Template Results" rightElement={<Return />} />
        {isLoading ? (
          <Loader />
        ) : isError ? (
          <ErrorDisplay />
        ) : (
          <Box display="flex" flexDirection="column">
            <Paper>
              <Tabs
                value={selectedTab}
                onChange={(_event, newValue) => setSelectedTab(newValue)}
                sx={{
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#006286',
                    textColor: '#006286',
                    color: '#006286',
                  },
                }}
              >
                <Tab label="Results" value={TABS.RESULTS_TAB} />
                <Tab label="Details" value={TABS.DETAILS_TAB} />
                <Tab label="RunTime" value={TABS.RUNTIME_TAB} />
                <Tab label="Comparison" value={TABS.COMPARISON_TAB} />
              </Tabs>
            </Paper>
            <Box display="flex">
              <TabPanel
                value={selectedTab}
                index={TABS.RESULTS_TAB}
                padding={0}
              >
                <ResultsView
                  templateOutputsData={templateOutputsData ?? []}
                  templateSummaryData={templateSummaryData ?? []}
                  isLoading={
                    isTemplateOutputsLoading || isTemplateSummaryLoading
                  }
                  width={width}
                  height={height}
                />
              </TabPanel>
              <TabPanel
                value={selectedTab}
                index={TABS.DETAILS_TAB}
                padding={0}
              >
                <DetailsView
                  data={templateOutputsData ?? []}
                  isLoading={isTemplateOutputsLoading}
                  width={width}
                  height={height}
                />
              </TabPanel>
              <TabPanel
                value={selectedTab}
                index={TABS.RUNTIME_TAB}
                padding={0}
              >
                <RunRateView
                  data={runRateData ?? []}
                  isLoading={isrunRateLoading}
                  width={width}
                  height={height}
                />
              </TabPanel>
              <TabPanel
                value={selectedTab}
                index={TABS.COMPARISON_TAB}
                padding={0}
              >
                {isTemplateComparisonLoading ? (
                  <Loader />
                ) : isTemplateComparisonError ? (
                  <ErrorDisplay />
                ) : templateComparison ? (
                  <ComparisonView
                    data={templateComparison}
                    isLoading={isTemplateComparisonLoading}
                    width={width}
                    height={height}
                  />
                ) : (
                  <ErrorDisplay />
                )}
              </TabPanel>
            </Box>
          </Box>
        )}
      </Box>
    </Page>
  )
}
